import React from 'react';

const ToggleItem = (props) => (
  <button
    className={`toggle-item ${(props.selected) ? 'selected' : ''}`}
    onClick={ props.onClick }
  >
    <span className="icon"></span>
    <span className="label">{ props.label }</span>
  </button>
);

export default ToggleItem;